(function () {
  if (window.CraftivorProductFormLoaded) return;
  window.CraftivorProductFormLoaded = true;

  var engravingSelector = 'input[name="properties[Engraving text]"], textarea[name="properties[Engraving text]"]';
  var placementSelector = 'select[name="properties[Engraving placement]"]';
  var noEngravingPattern = /\bno\s+(laser\s+)?engraving\b/i;
  var engravingChoicePattern = /\b(add\s+laser\s+engraving|engraved|engraving|engrave|front side|inside right|inside left|back side)\b/i;
  var watchBandTextMax = 15;

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getProductForms(root) {
    root = root || document;
    var forms = Array.prototype.slice.call(root.querySelectorAll('form[data-type="add-to-cart-form"]'));
    if (root.matches && root.matches('form[data-type="add-to-cart-form"]')) {
      forms.unshift(root);
    }
    return forms;
  }

  function getVariantTexts(form) {
    var select = form.querySelector('select[name="id"]');
    if (!select) return [];
    return Array.prototype.map.call(select.options, function (option) {
      return normalize(option.textContent);
    }).filter(Boolean);
  }

  function getSelectedVariantText(form) {
    var select = form.querySelector('select[name="id"]');
    if (!select || !select.selectedOptions.length) return '';
    return normalize(select.selectedOptions[0].textContent);
  }

  function getEngravingField(form) {
    return form.querySelector(engravingSelector);
  }

  function getPlacementField(form) {
    return form.querySelector(placementSelector);
  }

  function isWatchBandForm(form) {
    return form.classList && form.classList.contains('craftivor-watch-band-product');
  }

  function requiresEngravingText(form) {
    return form.classList && form.classList.contains('craftivor-requires-engraving-text');
  }

  function disallowsEngraving(form) {
    return form.classList && form.classList.contains('craftivor-no-engraving-product');
  }

  function getPersonalizationState(form) {
    var variantTexts = getVariantTexts(form);
    var selectedText = getSelectedVariantText(form);
    var hasEngravingChoice = variantTexts.some(function (text) {
      return noEngravingPattern.test(text) || engravingChoicePattern.test(text);
    });
    var selectedNoEngraving = noEngravingPattern.test(selectedText);

    return {
      selectedNoEngraving: selectedNoEngraving,
      requiresText: requiresEngravingText(form) || (hasEngravingChoice && !selectedNoEngraving)
    };
  }

  function updateHelperText(wrapper, requiresText, maxLength) {
    if (!wrapper) return;

    var helper = wrapper.querySelector('p');
    if (!helper) return;

    if (!helper.getAttribute('data-optional-text')) {
      helper.setAttribute('data-optional-text', normalize(helper.textContent) || 'Optional. Enter a name, initials, date, or short phrase exactly as it should appear.');
    }

    var maxSuffix = maxLength ? ' ' + maxLength + ' characters max.' : '';
    helper.textContent = requiresText
      ? 'Required for the selected engraving option. Enter the text exactly as it should appear.' + maxSuffix
      : helper.getAttribute('data-optional-text');
  }

  function setEngravingTextLimit(form, field) {
    if (!field || !isWatchBandForm(form)) return null;
    field.setAttribute('maxlength', String(watchBandTextMax));
    field.setAttribute('data-max-length', String(watchBandTextMax));
    return watchBandTextMax;
  }

  function setVisibility(field, wrapper, visible, required, clearValue) {
    if (!field) return;

    field.disabled = !visible;
    field.required = Boolean(visible && required);
    if (clearValue) {
      field.value = '';
      field.setCustomValidity('');
    }
    if (field.required) {
      field.setAttribute('data-field-required', '');
    } else {
      field.removeAttribute('data-field-required');
    }
    if (wrapper) {
      wrapper.hidden = !visible;
      if (!visible) {
        wrapper.classList.remove('is--field-emty', 'is--animated', 't4s-ani-shake');
      }
    }
  }

  function setFieldState(form) {
    var field = getEngravingField(form);
    var fieldWrapper = field && field.closest('[data-item-property-field]');
    var placementField = getPlacementField(form);
    var placementWrapper = placementField && placementField.closest('[data-item-property-field]');
    var state = getPersonalizationState(form);
    var hidePersonalization = state.selectedNoEngraving || disallowsEngraving(form);
    var textMax = setEngravingTextLimit(form, field);

    if (hidePersonalization) {
      updateHelperText(fieldWrapper, false, textMax);
      setVisibility(field, fieldWrapper, false, false, true);
      setVisibility(placementField, placementWrapper, false, false, true);
      return;
    }

    setVisibility(field, fieldWrapper, Boolean(field), state.requiresText, false);
    updateHelperText(fieldWrapper, state.requiresText, textMax);

    if (placementField) {
      setVisibility(placementField, placementWrapper, isWatchBandForm(form), state.requiresText, false);
    }
  }

  function disableYmqProperties(form) {
    Array.prototype.forEach.call(form.querySelectorAll('[name^="properties[_Ymq"], [name^="properties[Ymq"]'), function (field) {
      field.disabled = true;
    });
  }

  function updateForm(form) {
    setFieldState(form);
    disableYmqProperties(form);
  }

  function updateAll(root) {
    getProductForms(root).forEach(updateForm);
  }

  function markInvalid(field) {
    var wrapper = field.closest('[data-item-property-field]');
    if (wrapper) {
      wrapper.hidden = false;
      wrapper.classList.add('is--field-emty', 'is--animated', 't4s-ani-shake');
      window.setTimeout(function () {
        wrapper.classList.remove('is--animated', 't4s-ani-shake');
      }, 900);
    }
    field.focus();
    if (field.reportValidity) field.reportValidity();
    return field;
  }

  function invalidPersonalizationTarget(target) {
    var form = target.closest && target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return null;
    updateForm(form);

    var placementField = getPlacementField(form);
    if (placementField && !placementField.disabled) {
      placementField.setCustomValidity('');
      if (placementField.required && !normalize(placementField.value)) {
        placementField.setCustomValidity('Choose an engraving placement.');
        return markInvalid(placementField);
      }
    }

    var field = getEngravingField(form);
    if (!field || field.disabled) return null;

    field.setCustomValidity('');
    var maxLength = Number(field.getAttribute('data-max-length') || 0);
    if (field.required && !normalize(field.value)) {
      field.setCustomValidity('Enter engraving text.');
      return markInvalid(field);
    }
    if (maxLength && field.value.length > maxLength) {
      field.setCustomValidity('Engraving text must be ' + maxLength + ' characters or fewer.');
      return markInvalid(field);
    }

    return null;
  }

  function scheduleUpdate(root) {
    updateAll(root || document);
    window.setTimeout(function () { updateAll(root || document); }, 80);
    window.setTimeout(function () { updateAll(root || document); }, 220);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleUpdate(document);
  });

  document.addEventListener('change', function (event) {
    var form = event.target.closest && event.target.closest('form[data-type="add-to-cart-form"]');
    if (form) scheduleUpdate(form);
  });

  document.addEventListener('input', function (event) {
    var form = event.target.closest && event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    if (event.target.matches && (event.target.matches(engravingSelector) || event.target.matches(placementSelector))) {
      event.target.setCustomValidity('');
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-atc-form]') && invalidPersonalizationTarget(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (event.target.closest && event.target.closest('[data-swatch-item], [data-dropdown-off], [data-dropdown-close]')) {
      scheduleUpdate(document);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (invalidPersonalizationTarget(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node.nodeType === 1) scheduleUpdate(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
